module.exports = __webpack_public_path__ + "img/ck3-castle-hill.9956e7fb.jpg";